/* eslint operator-linebreak: 0, no-unused-vars: 0, no-nested-ternary: 0 */
import FetcherFactory from '../factory.js'

/**
 * @class
 */
export default class FakeFetcher {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   */
  constructor({
    config,
    vehicleInfoResponseTemplate,
    draftResponseTemplate,
    draftCreateResponseTemplate,
    draftUpdateResponseTemplate,
    draftPublishResponseTemplate,
    paymentMethodsResponseTemplate,
    purchaseResponseTemplate,
    purchaseDetailsResponseTemplate,
    orderResponseTemplate
  }) {
    this._config = config
    this._httpFetcher = FetcherFactory.httpFetcher({config})
    this._patterns = []
    this._patterns.push([/vehicleInfo/, vehicleInfoResponseTemplate])
    this._patterns.push([/drafts\/\?/, draftResponseTemplate])
    this._patterns.push([/drafts\/\d/, draftPublishResponseTemplate])
    this._patterns.push([/orders/, orderResponseTemplate])
    this._patterns.push([/payment-gateways\/adyen\/payment-methods/, paymentMethodsResponseTemplate])
    this._patterns.push([/payment-gateways\/adyen\/payments\/$/, purchaseResponseTemplate])
    this._putPatterns = []
    this._putPatterns.push([/drafts\/$/, draftCreateResponseTemplate])
    this._putPatterns.push([/drafts\/\d/, draftUpdateResponseTemplate])
    this._putPatterns.push([/payment-gateways\/adyen\/payments\/\d/, purchaseDetailsResponseTemplate])
  }

  /**
   * @method
   * @param {String} url
   * @param {Object} options
   */
  get(url, options) {
    const appName = this._config.get('APP_NAME')

    const [path, action] = this._patterns.find(([path, action]) => path.test(url)) || []
    return action ? Promise.resolve({data: action.build({url, options, appName})}) : this._httpFetcher.get(url, options)
  }

  /**
   * @method
   * @param {String} url
   * @param {Object} body
   * @param {Object} options
   */
  post(url, body, options) {
    const [path, action] = this._patterns.find(([path, action]) => path.test(url)) || []

    const fakeResponse =
      action &&
      action.build({
        body
      })

    return action
      ? fakeResponse && fakeResponse.status
        ? Promise.resolve(fakeResponse)
        : Promise.reject(fakeResponse)
      : this._httpFetcher.post(url, body, options)
  }

  /**
   * @method
   * @param {String} url
   * @param {Object} body
   * @param {Object} options
   */
  put(url, body, options) {
    const [path, action] = this._putPatterns.find(([path, action]) => path.test(url)) || []
    return action ? Promise.resolve(action.build({url, body})) : this._httpFetcher.put(url, body, options)
  }

  /**
   * @method
   * @param {String} url
   * @param {Object} options
   */
  delete(url, options) {
    return this._httpFetcher.delete(url, options)
  }
}
